import { parseDateValue } from '../utils/formatUtils';
import React, { useEffect,  useRef, useState } from 'react';
import * as d3 from 'd3';
import cloud from 'd3-cloud';
import axios from 'axios';
import { getAPIUrl } from '../api/apiUtils';
import { useGlobalFilters, useGlobalFiltersForAPI } from '../hooks/useGlobalFilters';

// Стоп-слова, которые нужно исключить из облака слов
const RUSSIAN_STOPWORDS = new Set([
  'ваш', 'который', 'оно', 'они', 'он', 'она', 'кто', 'что', 'то', 'тот', 'это', 'этот',
  'себя', 'ни', 'не', 'их', 'его', 'её', 'ее'
]);

// Группы для выпадающего списка (отображение)
const CATEGORY_GROUPS = {
  // 'Желание': [
  //   { label: 'Чувствовать', key: 'чувствовать' },
  //   { label: 'Хотеть', key: 'хотеть' },
  //   { label: 'Перехотеть', key: 'перехотеть' },
  //   { label: 'Желать', key: 'желать' },
  // ],
  // 'Потребность': [
  //   { label: 'Нуждаться', key: 'нуждаться' },
  //   { label: 'Требовать', key: 'требовать' },
  //   { label: 'Искать', key: 'искать' },
  // ],
  // 'Надежда': [
  //   { label: 'Ждать', key: 'ждать' },
  //   { label: 'Верить', key: 'верить' },
  //   { label: 'Надеяться', key: 'надеяться' },
  // ],
  'Страх': [
    { label: 'Бояться', key: 'бояться' },
  ],
  // 'Планирование': [
  //   { label: 'Пытаться', key: 'пытаться' },
  //   { label: 'Стараться', key: 'стараться' },
  //   { label: 'Планировать', key: 'планировать' },
  //   { label: 'Собираться', key: 'собираться' },
  //   { label: 'Готовиться', key: 'готовиться' },
  //   { label: 'Вздуматься', key: 'вздуматься' },
  //   { label: 'Решаться', key: 'решаться' },
  //   { label: 'Торопиться', key: 'торопиться' },
  // ],
  // 'Результат усилий': [
  //   { label: 'Добиваться', key: 'добиваться' },
  //   { label: 'Справляться', key: 'справляться' },
  //   { label: 'Смочь', key: 'смочь' },
  // ],
  'Страдание': [
    { label: 'Страдать', key: 'страдать' },
    { label: 'Переживать', key: 'переживать' },
    { label: 'Хренеть', key: 'хренеть' },
    { label: 'Уставать', key: 'уставать' },
    { label: 'Травиться', key: 'травиться' },
    { label: 'Жалеть', key: 'жалеть' },
    { label: 'Надоедать', key: 'надоедать' },
    { label: 'Плакать', key: 'плакать' },
    { label: 'Ныть', key: 'ныть' },
  ],
  // 'Позитивное отношение': [
  //   { label: 'Любить', key: 'любить' },
  //   { label: 'Нравиться', key: 'нравиться' },
  //   { label: 'Уважать', key: 'уважать' },
  //   { label: 'Гордиться', key: 'гордиться' },
  // ],
  // 'Негативное отношение': [
  //   { label: 'Ненавидеть', key: 'ненавидеть' },
  //   { label: 'Завидовать', key: 'завидовать' },
  //   { label: 'Смеяться', key: 'смеяться' },
  // ],
  // 'Пассивное отношение': [
  //   { label: 'Плевать', key: 'плевать' },
  //   { label: 'Терпеть', key: 'терпеть' },
  //   { label: 'Привыкать', key: 'привыкать' },
  //   { label: 'Отдыхать', key: 'отдыхать' },
  // ],
  // 'Активное отношение': [
  //   { label: 'Будить', key: 'будить' },
  //   { label: 'Бороться', key: 'бороться' },
  // ],
};

// Компонент выпадающего списка для фильтра по группам
const GroupPredicateDropdown = ({ predicateGroups, selectedGroups, setSelectedGroups, PREDICATE_GROUPS_KEY }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Закрываем выпадающий список при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleGroup = (categoryName) => {
    const newGroups = selectedGroups.includes(categoryName)
      ? selectedGroups.filter(g => g !== categoryName)
      : [...selectedGroups, categoryName];
    console.log('Изменяем категории:', newGroups);
    setSelectedGroups(newGroups);
  };

  const selectAll = () => {
    const allCategories = Object.keys(CATEGORY_GROUPS);
    console.log('Выбираем все категории:', allCategories);
    setSelectedGroups(allCategories);
  };

  const clearAll = () => {
    console.log('Очищаем выбор групп');
    setSelectedGroups([]);
  };

  const resetAll = () => {
    console.log('Сбрасываем все фильтры');
    setSelectedGroups([]);
    localStorage.removeItem(PREDICATE_GROUPS_KEY);
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ marginBottom: '8px' }}>
        <label style={{ 
          fontWeight: 600, 
          color: '#495057',
          fontSize: '14px',
          display: 'block',
          marginBottom: '8px'
        }}>
          Фильтр по группам предикатов:
        </label>
        <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block', width: '100%', maxWidth: '400px' }}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #d0d7de',
              borderRadius: '6px',
              background: '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '14px'
            }}
          >
            <span>
              {selectedGroups.length === 0 
                ? 'Выберите группы...' 
                : `Выбрано групп: ${selectedGroups.length}`
              }
            </span>
            <span style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
          </button>
          
          {isOpen && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              background: '#fff',
              border: '1px solid #d0d7de',
              borderRadius: '6px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
              maxHeight: '300px',
              overflowY: 'auto'
            }}>
              {/* Кнопки управления */}
              <div style={{
                padding: '8px',
                borderBottom: '1px solid #e9ecef',
                display: 'flex',
                gap: '8px',
                justifyContent: 'space-between'
              }}>
                <button onClick={selectAll} style={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  border: '1px solid #d0d7de',
                  borderRadius: '4px',
                  background: '#fff',
                  cursor: 'pointer',
                  color: '#374151',
                  flex: 1
                }}>
                  Выбрать все
                </button>
                <button onClick={clearAll} style={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  border: '1px solid #d0d7de',
                  borderRadius: '4px',
                  background: '#fff',
                  cursor: 'pointer',
                  color: '#374151',
                  flex: 1
                }}>
                  Очистить
                </button>
                <button onClick={resetAll} style={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  border: '1px solid #dc3545',
                  borderRadius: '4px',
                  background: '#fff',
                  cursor: 'pointer',
                  color: '#dc3545',
                  flex: 1
                }}>
                  Сбросить
                </button>
              </div>
              
              {/* Список категорий */}
              <div style={{ padding: '4px 0' }}>
                {Object.entries(CATEGORY_GROUPS).map(([category, items]) => (
                  <div key={category} style={{ padding: '6px 0' }}>
                    <label style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '6px 12px',
                      cursor: 'pointer',
                      fontSize: '13px',
                      transition: 'background-color 0.2s ease',
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#f5f5f5'}
                    onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                    >
                      <input
                        type="checkbox"
                        checked={selectedGroups.includes(category)}
                        onChange={() => toggleGroup(category)}
                        style={{
                          marginRight: '8px',
                          cursor: 'pointer'
                        }}
                      />
                      <span style={{ fontWeight: 700, color: '#374151' }}>{category}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* Отображение выбранных групп */}
      {selectedGroups.length > 0 && (
        <div style={{
          marginTop: '8px',
          padding: '8px',
          background: '#f8f9fa',
          borderRadius: '6px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{
            fontSize: '12px',
            color: '#666',
            marginBottom: '4px'
          }}>
            Выбранные группы ({selectedGroups.length}):
          </div>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px'
          }}>
            {selectedGroups.map(groupName => (
              <span key={groupName} style={{
                padding: '2px 6px',
                background: '#e3f2fd',
                color: '#1976d2',
                borderRadius: '12px',
                fontSize: '11px',
                border: '1px solid #bbdefb'
              }}>
                {groupName}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const API_URL = getAPIUrl();

const PREDICATE_GROUPS_KEY = 'selectedPredicateGroups_wordcloud';

const predicate_groups = {
  "хотеть":["хотеть", "захотеть", "хотеться", "захотеться"],
  "перехотеть":["перехотеть", "расхотеть", "расхотеться", "перехотеться", "нехотеть", "нихотеть", "нехотеться"],
  "ждать":["ждать", "подождать", "заждаться", "дождаться", "дожидаться", "обождать", "переждать", "пережидать", "поджидать", "недождаться", "недожидаться", "неждать"],
  "верить":["верить", "вериться", "поверить", "уверовать", "веровать", "вериться", "неверить"],
  "бояться":["бояться", "побояться", "забояться", "побаиваться", "небояться"],
  "смочь":["смочь", "несмочь"],
  "надеяться":["надеяться", "понадеяться"],
  "пытаться":["пытаться", "попытаться"],
  "страдать":["страдать", "пострадать"],
  "переживать":["переживать", "испереживаться", "расп", "запереживать", "непереживать"],
  "желать":["желать", "пожелать", "нежелать"],
  "любить":["любить", "нелюбить"],
  "нравиться":["нравиться", "ненравиться"],
  "ныть":["ныть", "поныть", "заныть", "разныться"],
  "плевать":["плевать", "наплевать"],
  "терпеть":["терпеть", "потерпеть", "вытерпеть", "перетерпеть"],
  "будить":["возбудить", "разбудить", "будить", "пробудить"],
  "отдыхать":["отдыхать", "отдохнуть", "передохнуть", "выдохнуть"],
  "бороться":["бороться", "побороться"],
  "стараться":["стараться", "постараться", "перестараться"],
  "чувствовать":["чувствовать", "почувствовать", "расчувствоваться"],
  "планировать":["планировать", "запланировать"],
  "плакать":["плакать", "поплакать", "выплакаться", "поплакаться", "заплакать"],
  "уважать":["уважать", "зауважать"],
  "привыкать":["привыкать", "привыкнуть", "свыкнуться", "обвыкнуться"],
  "готовиться":["готовиться", "приготовиться"],
  "жалеть":["жалеть", "пожалеть", "сожалеть"],
  "надоедать":["надоедать", "надоесть"],
  "смеяться":["смеяться", "посмеяться", "рассмеяться", "высмеять", "засмеять"],
  "добиваться":["добиваться", "добиться"],
  "справляться":["справляться", "справиться"],
  "хренеть":["хренеть", "охренеть", "захренеть"],
  "уставать":["уставать", "устать"],
  "травиться":["травиться", "отравиться", "травануться"],
  "вздуматься":["вздуматься", "вздумать"],
  "завидовать":["завидовать", "позавидовать", "обзавидоваться"],
  "ненавидеть":["ненавидеть", "возненавидеть"],
  "решаться":["решаться", "решиться"],
  "торопиться":["торопиться", "заторопиться", "поторопиться"],
  "нуждаться":["нуждаться"],
  "гордиться":["гордиться", "погордиться", "загордиться"],
  "требовать":["требовать", "потребовать", "затребовать", "вытребовать"],
  "искать":["искать", "поискать", "разыскать", "сыскать", "сыскивать", "изыскать", "изыскивать", "подискать", "подискивать", "отискивать", "выискать", "подыскать", "подыскивать", "разыскивать", "выискивать", "доискиваться", "обыскаться", "отыскать", "отыскивать"],
  "собираться":["собираться", "собираться", "засобираться", "подсобираться"],
}

const containerStyle = {
  background: 'white',
  borderRadius: '8px',
  padding: '16px',
};

const statsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
  gap: '12px',
  marginBottom: '12px',
};

const statBoxStyle = {
  background: '#f8f9fa',
  border: '1px solid #e9ecef',
  borderRadius: '8px',
  padding: '12px',
  textAlign: 'center',
};



const svgWrapperStyle = {
  textAlign: 'center',
  overflow: 'hidden',
};

export default function WordCloud({ data, onWordClick, selectedGroups, setSelectedGroups }) {
  const [predicateGroups, setPredicateGroups] = useState(predicate_groups);
  const [wordcloudData, setWordcloudData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chartLoading, setChartLoading] = useState(false);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({ totalLemmas: 0, uniqueLemmas: 0, filteredByGroup: 'Все группы' });
  const svgRef = useRef(null);
  
  // Используем глобальные фильтры
  const filtersStore = useGlobalFilters();
  

  // Режим 1: работаем от уже загруженных данных страницы (приходит через prop data)
  const hasExternalData = Array.isArray(data) && data.length > 0;
  
  console.log('hasExternalData:', hasExternalData, 'data:', data);

  // Сохраняем выбранные фильтры в localStorage
  useEffect(() => {
    try {
      localStorage.setItem(PREDICATE_GROUPS_KEY, JSON.stringify(selectedGroups));
      console.log('💾 Сохранены фильтры:', selectedGroups);
    } catch (error) {
      console.warn('Ошибка сохранения фильтров:', error);
    }
  }, [selectedGroups]);

  useEffect(() => {
    if (hasExternalData) {
      // Строим частотный словарь из поля causators с фильтрацией по predicate_group
      const wordCounts = {};
      let total = 0;
      // Разворачиваем выбранные категории в допустимые ключи групп
      const allowedKeys = new Set();
      if (selectedGroups.length > 0) {
        selectedGroups.forEach(cat => {
          (CATEGORY_GROUPS[cat] || []).forEach(item => allowedKeys.add(item.key));
        });
      }
  
      data.forEach((item) => {
        if (!item || !item.causators || !item.predicate_group) return;
  
        // Проверяем, входит ли predicate_group в selectedGroups
        if (selectedGroups.length > 0 && !allowedKeys.has(item.predicate_group)) {
          return; // Пропускаем, если predicate_group не в selectedGroups
        }
  
        try {
          const causators = typeof item.causators === 'string' ? JSON.parse(item.causators) : item.causators;
          if (causators && typeof causators === 'object') {
            Object.entries(causators).forEach(([key, value]) => {
              const cleanKey = String(key).replace(/[^\w\sа-яё\-]/gi, '').trim().toLowerCase();
              if (cleanKey && cleanKey.length > 1 && !RUSSIAN_STOPWORDS.has(cleanKey)) {
                wordCounts[cleanKey] = (wordCounts[cleanKey] || 0) + 1;
                total += 1;
              }
              if (typeof value === 'string') {
                const cleanVal = value.replace(/[^\w\sа-яё\-]/gi, '').trim().toLowerCase();
                if (cleanVal && cleanVal.length > 1 && !RUSSIAN_STOPWORDS.has(cleanVal)) {
                  wordCounts[cleanVal] = (wordCounts[cleanVal] || 0) + 1;
                  total += 1;
                }
              }
            });
          }
        } catch (_) {
          // Пропускаем ошибки парсинга
        }
      });
  
      const entries = Object.entries(wordCounts)
        .map(([text, value]) => ({ text, value }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 100);
  
      setWordcloudData(entries);
      setStats({
        totalLemmas: total,
        uniqueLemmas: Object.keys(wordCounts).length,
        filteredByGroup: selectedGroups.length > 0 ? `Выбрано групп: ${selectedGroups.length}` : 'Из данных страницы',
      });
      setLoading(false);
      setError('');
    }
  }, [hasExternalData, data, selectedGroups]); // Добавляем selectedGroups в зависимости

  // Режим 2: автономная загрузка с API (если data не переданы)
  useEffect(() => {
    if (hasExternalData) return;
    // Загружаем группы предикатов
    loadPredicateGroups();
  }, [hasExternalData]);

  useEffect(() => {
    console.log('useEffect сработал! hasExternalData:', hasExternalData, 'selectedGroups:', selectedGroups);
    if (!hasExternalData) {
      console.log('Загружаем данные для групп:', selectedGroups);
      loadWordcloudData(selectedGroups);
      loadChartData(selectedGroups); // Загружаем данные для графика
    } else {
      console.log('Пропускаем загрузку - используются внешние данные');
    }
  }, [selectedGroups, hasExternalData]);

  useEffect(() => {
    if (wordcloudData.length > 0) {
      renderWordCloud();
    } else {
      // Очистка SVG, если данных нет
      if (svgRef.current) d3.select(svgRef.current).selectAll('*').remove();
    }
  }, [wordcloudData]);

  // Добавляем обработчик клика через React ref
  useEffect(() => {
    if (svgRef.current && onWordClick) {
      const handleClick = (event) => {
        // Проверяем, кликнули ли по текстовому элементу
        if (event.target.tagName === 'text') {
          const fullText = event.target.textContent;
          
          // Извлекаем только слово (до двоеточия, если есть)
          const word = fullText.split(':')[0].trim();
          
          // Находим данные для этого текста
          const wordData = wordcloudData.find(d => d.text === word);
          if (wordData) {
            onWordClick(wordData.text, wordData.value);
          }
        }
      };
      
      svgRef.current.addEventListener('click', handleClick);
      
      return () => {
        if (svgRef.current) {
          svgRef.current.removeEventListener('click', handleClick);
        }
      };
    }
  }, [wordcloudData, onWordClick]);


  const loadPredicateGroups = async () => {
    try {
      const response = await axios.get(`${API_URL}/predicate-groups-csv`);
      const data = response.data;
      if (Array.isArray(data)) {
        // Если с бэкенда приходит массив групп, конвертируем в объект
        const groupsObject = {};
        data.forEach(group => {
          groupsObject[group] = []; // Пустой массив, так как детали не нужны
        });
        setPredicateGroups(groupsObject);
      } else if (typeof data === 'object') {
        setPredicateGroups(data);
      }
    } catch (error) {
      // Тихо игнорируем, компонент работает с предустановленными группами
      console.warn('Ошибка загрузки групп предикатов:', error);
    }
  };

  const loadWordcloudData = async (groups = []) => {
    console.log('🚀 loadWordcloudData вызвана с группами:', groups);
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams();
  
      // Базовые параметры
      params.append('causators_only', 'true');
      params.append('limit', '1000');
  
      // Добавляем даты из глобальных фильтров
      const startDate = filtersStore.filters?.startDate || '2017-01-01';
      const endDate = filtersStore.filters?.endDate || new Date().toISOString().split('T')[0];
      params.append('start_date', startDate);
      params.append('end_date', endDate);
  
      // Добавляем group_ids из глобальных фильтров
      const selectedGroupIds = filtersStore.filters?.selectedGroups || [];
      if (selectedGroupIds.length > 0) {
        params.append('group_ids', selectedGroupIds.join(','));
      } else {
        params.append('group_ids', '-32444926,-35911547,-62818221,-818023');
      }
  
      // Добавляем леммы из выбранных категорий
      if (groups.length > 0) {
        const selectedLemmas = [];
        groups.forEach(category => {
          const items = CATEGORY_GROUPS[category] || [];
          items.forEach(({ key }) => {
            const lemmas = predicateGroups[key] || [];
            selectedLemmas.push(...lemmas);
          });
        });
        if (selectedLemmas.length > 0) {
          selectedLemmas.forEach(lemma => {
            params.append('causator_lemma', lemma);
          });
        }
      }
  
      const url = `${API_URL}/v1_0/detection/srl_analysis?${params.toString()}`;
      console.log('Отправляем запрос:', url);
      console.log('Выбранные группы:', groups);
      console.log('Параметры запроса:', params.toString());
  
      const response = await axios.get(url);
      const payload = response.data || {};
      const apiData = payload.data || [];
  
      console.log('Получен ответ от API:', payload);
      console.log('Количество записей:', apiData.length);
  
      // Обрабатываем данные для облака слов с фильтрацией по predicate_group
      const wordCounts = {};
      let totalWords = 0;
  
      apiData.forEach(item => {
        if (item.causators && typeof item.causators === 'object' && item.predicate_group) {
          // Проверяем, входит ли predicate_group в выбранные группы
          if (groups.length > 0 && !groups.includes(item.predicate_group)) {
            return; // Пропускаем, если predicate_group не в selectedGroups
          }
  
          Object.entries(item.causators).forEach(([word, count]) => {
            const cleanWord = word.replace(/[^\w\sа-яё\-]/gi, '').trim().toLowerCase();
            if (cleanWord && cleanWord.length > 1 && !RUSSIAN_STOPWORDS.has(cleanWord)) {
              wordCounts[cleanWord] = (wordCounts[cleanWord] || 0) + (count || 1);
              totalWords += (count || 1);
            }
          });
        }
      });
  
      // Преобразуем в формат для облака слов
      const wordCloudItems = Object.entries(wordCounts)
        .map(([text, value]) => ({ text, value }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 100);
  
      console.log('Обработанные данные для облака слов:', wordCloudItems);
  
      setWordcloudData(wordCloudItems);
      setStats({
        totalLemmas: totalWords,
        uniqueLemmas: Object.keys(wordCounts).length,
        filteredByGroup: groups.length > 0 ? `Выбрано групп: ${groups.length}` : 'Все группы',
      });
    } catch (error) {
      setError(error.response?.data?.message || error.message || 'Ошибка загрузки данных облака слов');
    } finally {
      setLoading(false);
    }
  };

  const loadChartData = async (groups = []) => {
    console.log('🚀 loadChartData вызвана с группами:', groups);
    setChartLoading(true);
    try {
      const params = new URLSearchParams();
      
      // Базовые параметры для графика
      params.append('causators_only', 'true');
      params.append('limit', '1000');
      
      // Добавляем даты из глобальных фильтров
      const startDate = filtersStore.filters?.startDate || '2017-01-01';
      const endDate = filtersStore.filters?.endDate || new Date().toISOString().split('T')[0];
      params.append('start_date', startDate);
      params.append('end_date', endDate);
      
      // Добавляем group_ids из глобальных фильтров
      const selectedGroupIds = filtersStore.filters?.selectedGroups || [];
      if (selectedGroupIds.length > 0) {
        params.append('group_ids', selectedGroupIds.join(','));
      } else {
        params.append('group_ids', '-32444926,-35911547,-62818221,-818023');
      }
      
      // Добавляем леммы из выбранных категорий
      if (groups.length > 0) {
        const selectedLemmas = [];
        groups.forEach(category => {
          const items = CATEGORY_GROUPS[category] || [];
          items.forEach(({ key }) => {
            const lemmas = predicateGroups[key] || [];
            selectedLemmas.push(...lemmas);
          });
        });
        if (selectedLemmas.length > 0) {
          selectedLemmas.forEach(lemma => {
            params.append('causator_lemma', lemma);
          });
        }
      }
      
      const url = `${API_URL}/v1_0/detection/srl_analysis?${params.toString()}`;
      
      console.log('Отправляем запрос для графика:', url);
      
      const response = await axios.get(url);
      const payload = response.data || {};
      const apiData = payload.data || [];
      
      console.log('Получены данные для графика:', payload);
      
      // Обрабатываем данные для графика (группировка по датам, например)
      const chartItems = processChartData(apiData);
      
      setChartData(chartItems);
    } catch (error) {
      console.error('Ошибка загрузки данных графика:', error);
      setError(error.response?.data?.message || error.message || 'Ошибка загрузки данных графика');
    } finally {
      setChartLoading(false);
    }
  };

  const processChartData = (apiData) => {
    // Группируем данные по датам для построения временного графика
    const dateGroups = {};
    
    apiData.forEach(item => {
      const parsedDate = parseDateValue(item.date);
      if (!parsedDate) return;
      const date = parsedDate.toISOString().split('T')[0];
      
      if (!dateGroups[date]) {
        dateGroups[date] = { date, count: 0, causators: {} };
      }
      
      dateGroups[date].count += 1;
      
      // Подсчитываем causators
      if (item.causators && typeof item.causators === 'object') {
        Object.keys(item.causators).forEach(causator => {
          if (!dateGroups[date].causators[causator]) {
            dateGroups[date].causators[causator] = 0;
          }
          dateGroups[date].causators[causator] += item.causators[causator];
        });
      }
    });
    
    // Преобразуем в массив и сортируем по датам
    return Object.values(dateGroups).sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const renderWordCloud = () => {
    if (!svgRef.current || wordcloudData.length === 0) return;
    const width = 800;
    const height = 500;

    // Очистка
    const root = d3.select(svgRef.current);
    root.selectAll('*').remove();

    const svg = root.attr('width', width).attr('height', height);
    const g = svg.append('g').attr('transform', `translate(${width / 2}, ${height / 2})`);


    const maxValue = d3.max(wordcloudData, d => d.value) || 1;
    const fontSize = d3.scaleLinear().domain([0, maxValue]).range([12, 60]);
    const color = d3.scaleOrdinal(d3.schemeCategory10);

    cloud()
      .size([width, height])
      .words(
        wordcloudData.map(d => ({ text: d.text, size: fontSize(d.value), value: d.value }))
      )
      .padding(5)
      .rotate(() => (0/*Math.random() > 0.5 ? 90 : 0*/))
      .font('Arial')
      .fontSize(d => d.size)
      .on('end', draw)
      .start();

    function draw(words) {
      const textElements = g.selectAll('text')
        .data(words)
        .enter()
        .append('text')
        .style('font-size', d => `${d.size}px`)
        .style('font-family', 'Arial')
        .style('font-weight', 'bold')
        .style('fill', (d, i) => color(i))
        .style('cursor', 'pointer')
        .attr('text-anchor', 'middle')
        .attr('transform', d => `translate(${d.x}, ${d.y}) rotate(${d.rotate})`)
        .text(d => d.text);

      // Добавляем title отдельно, не через append
      textElements.append('title')
        .text(d => `${d.text}: ${d.value}`);

      // Добавляем обработчик клика после создания элементов
      textElements.on('click', function(event, d) {
        if (onWordClick) {
          onWordClick(d.text, d.value);
        }
      });
    }
  };

  const renderChart = () => {
    if (chartData.length === 0) return null;

    const chartWidth = 800;
    const chartHeight = 300;
    const margin = { top: 20, right: 30, bottom: 40, left: 50 };
    const width = chartWidth - margin.left - margin.right;
    const height = chartHeight - margin.top - margin.bottom;

    // Создаем SVG для графика
    const chartContainer = (
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <h4>Временной график активности</h4>
        <svg width={chartWidth} height={chartHeight} style={{ border: '1px solid #ddd' }}>
          <g transform={`translate(${margin.left}, ${margin.top})`}>
            {/* Здесь будет простой график */}
            {chartData.map((item, index) => (
              <g key={index}>
                <circle
                  cx={(index / (chartData.length - 1)) * width}
                  cy={height - (item.count / Math.max(...chartData.map(d => d.count))) * height}
                  r="3"
                  fill="#1976d2"
                />
                {index < chartData.length - 1 && (
                  <line
                    x1={(index / (chartData.length - 1)) * width}
                    y1={height - (item.count / Math.max(...chartData.map(d => d.count))) * height}
                    x2={((index + 1) / (chartData.length - 1)) * width}
                    y2={height - (chartData[index + 1].count / Math.max(...chartData.map(d => d.count))) * height}
                    stroke="#1976d2"
                    strokeWidth="2"
                  />
                )}
              </g>
            ))}
            {/* Оси */}
            <line x1="0" y1={height} x2={width} y2={height} stroke="#333" />
            <line x1="0" y1="0" x2="0" y2={height} stroke="#333" />
          </g>
        </svg>
        {chartLoading && <div>Загрузка графика...</div>}
      </div>
    );

    return chartContainer;
  };

  return (
    <div style={containerStyle}>
      <h3 style={{ marginTop: 0, marginBottom: 12 }}>Причины эмоций</h3>

      {/* Фильтр по группам предикатов - перенесен наверх */}
      <GroupPredicateDropdown 
        predicateGroups={predicateGroups}
        selectedGroups={selectedGroups}
        setSelectedGroups={setSelectedGroups}
        PREDICATE_GROUPS_KEY={PREDICATE_GROUPS_KEY}
      />

      {loading ? (
        <div style={{ textAlign: 'center', padding: 50 }}>Загрузка…</div>
      ) : wordcloudData.length > 0 ? (
        <div style={svgWrapperStyle}>
          <svg ref={svgRef} style={{ maxWidth: '100%', height: 'auto' }} />
        </div>
      ) : error ? (
        <div style={{ color: '#d32f2f', padding: 12 }}>Ошибка: {error}</div>
      ) : (
        <div style={{ textAlign: 'center', padding: 50, color: '#666' }}>Нет данных для отображения</div>
      )}

      {/* Отображаем график */}
      {renderChart()}

      <div style={{ marginTop: 12, fontSize: 12, color: '#666' }}>
        <p><strong>Инструкция:</strong></p>
        <ul style={{ marginLeft: 18 }}>
          <li>Выберите группу предикатов для фильтрации данных</li>
          <li>Размер слова соответствует частоте леммы</li>
          <li>Клик по слову показывает частоту во всплывающей подсказке</li>
          <li>Клик по слову открывает детальную информацию о постах с этим каузатором</li>
        </ul>
      </div>


      {/* Статистика перенесена в самый низ */}
      <div style={statsGridStyle}>
        <div style={statBoxStyle}>
          <div style={{ fontSize: 12, color: '#666' }}>Всего лемм</div>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#3f8600' }}>{stats.totalLemmas}</div>
        </div>
        <div style={statBoxStyle}>
          <div style={{ fontSize: 12, color: '#666' }}>Уникальных лемм</div>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#1890ff' }}>{stats.uniqueLemmas}</div>
        </div>
        <div style={statBoxStyle}>
          <div style={{ fontSize: 12, color: '#666' }}>Активный фильтр</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#722ed1' }}>{stats.filteredByGroup}</div>
        </div>
      </div>
    </div>
  );
}


